import React, { useState, useEffect } from 'react'
import { injectIntl, Link } from 'gatsby-plugin-intl'
import { useStaticQuery, graphql } from 'gatsby'
import Language from './language'
import styled from 'styled-components'
import { breakpoints, colors } from '../utils/utils'
import NavBar from './navBar'
import MobileNavBar from '../components/mobileNavBar'
import { IoIosMenu } from 'react-icons/io'

export default injectIntl( props => {

    const [ menuFixed, setMenuFixed ] = useState(false)
    const [ menuOpen, setMenuOpen ] = useState(false)

    const handleScroll = () => {    
        if (document.documentElement.scrollTop >= 37) {
            setMenuFixed(true)
        } else {
            setMenuFixed(false)
        }
    }

    useEffect(() => {  
        if(typeof window !== 'undefined') {
            window.addEventListener('scroll', handleScroll)
        }
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    },[])

  const data = useStaticQuery(graphql`
    query{
      allContentfulMenu(filter: {name: {eq: "Header"} }) {
        edges {
          node {
            node_locale
            links {
              id
              value
              href
              contentful_id
              }
            }
          }
        }
        contentfulAsset(contentful_id: {eq: "1YsjqKpFPCCABORm9if6Aa"}) {
          title
          file {
            url
          }
        }
      }
  `)

  const lang = props.intl.locale

  const contactUsLink = data.allContentfulMenu.edges.filter( d => (d.node.node_locale === lang))[0].node.links
  .map( link => {
      if(link.contentful_id === '3fcaKpt7smFevEsbgMLkxZ') {
          return <Link key={link.id} to={`/${props.intl.locale}/${link.href}`} >{link.value}</Link>
      } else {
          return ''
      }
  })

  const aboutUsSubmenu = data.allContentfulMenu.edges.filter( d => (d.node.node_locale === lang))[0].node.links
  .map( link => {
      if(link.contentful_id === '4OinIsOhOAs69prCO1d3LU' || link.contentful_id === '7JYRW0bESVsC9hx2Z65QgZ') {
          return <Link key={link.id} to={`/${props.intl.locale}/${link.href}`} >{link.value}</Link>
      } else {
          return ''
      }
  })

  const Links = data.allContentfulMenu.edges.filter( d => (d.node.node_locale === lang))[0].node.links
  .map( (link, index) =>
  link.contentful_id === '3fcaKpt7smFevEsbgMLkxZ' || link.contentful_id === '4OinIsOhOAs69prCO1d3LU' || link.contentful_id === '7JYRW0bESVsC9hx2Z65QgZ' ?
        ''
    :
        <li key={index}>
            {
                
                link.contentful_id === '1oR7tJZeYDmJ4EIs0QW03S' ?
                    <Link to={`/${props.intl.locale}/${link.href}`} state={{isOptionSelected: false}}>{link.value}</Link>
                :
                    link.contentful_id === '5npJlIUThqQITw64SwyXoY' ?
                        <div className="submenu">
                            <Link to={`/${props.intl.locale}/${link.href}`} >{link.value}</Link>
                            <div className="submenu-block">
                                {aboutUsSubmenu}
                            </div>
                        </div>
                    :
                        <Link to={`/${props.intl.locale}/${link.href}`} >{link.value}</Link>
            }
        </li>
  )

  const handleClickMenu = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <>
        <Header menuFixed={menuFixed} className="headerSection">
            <Logo>
                <Link to={`/${props.intl.locale}`} ><img src={data.contentfulAsset.file.url} alt={data.contentfulAsset.title} /></Link>
            </Logo>        
            <NavBar links={Links}/>
            <LeftBlock>
                <LanguageBlock>
                    <Language locale={props.intl.locale}/>
                </LanguageBlock>
                <ContactUs>{contactUsLink}</ContactUs>
            </LeftBlock>
            <Nav>
                <IoIosMenu className="menu-icon" onClick={() => handleClickMenu()}/>
            </Nav>
        </Header>
        <MobileNavBar links={Links} contactUs={contactUsLink} handleClickMenu={handleClickMenu} menuOpen={menuOpen}/>
    </>
  )
})

const Nav = styled.nav`
  display: none;
  padding: 1em;

  .menu-icon {
    color: ${colors.tertiary};
    font-size: 3rem;
    cursor: pointer;
  }

  ${breakpoints.md}{
    display:block;
  }
`

const ContactUs = styled.div`
    a {
        display: block;
        padding: .5rem 1rem;
        background-color: ${colors.secondary};
        color: ${colors.quaternary};
        text-decoration: none;
    }
    ${breakpoints.md}{
        display: none;
    }
`

const LeftBlock = styled.div`
    display: flex;
    flex-direction: row;
    margin-right: 1.5rem;
    ${breakpoints.lg}{
        margin-right: .7rem;
    }
    ${breakpoints.md}{
        width: 100%;
        margin: 0;
    }
`

const LanguageBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 1.5rem;
    ${breakpoints.lg}{
        margin-right: .7rem;
    }
    ${breakpoints.md}{
        margin: auto;
        margin-right: 0;
    }
`

const Header = styled.section`
  background: ${({menuFixed}) => menuFixed ? 'linear-gradient(0deg,transparent,rgba(12,0,38,0.90),rgba(12,0,38,0.92),rgba(12,0,38,0.92),rgba(12,0,38,0.92),rgba(12,0,38,0.92))' : 'linear-gradient(0deg, transparent, rgba(0, 0, 0, 0.2),  rgba(0, 0, 0, 0.5));'};
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;  
`
const Logo = styled.div`
  margin: 0 0 0 3rem;
  img {
    width: 125px;
    transform: scale(1.5);
    ${breakpoints.md}{ 
        transform: scale(1);
    }
  }
  ${breakpoints.md}{ 
    margin: 0 1rem;
  }
  ${breakpoints.lg}{ 
      margin: 0 0 0 1.5rem;
  }

`

